import React, { ReactNode } from "react";
import { Check } from "lucide-react";
import styles from "./Bullets.module.scss";

interface BulletListProps {
  children: ReactNode;
}

export const BulletList: React.FC<BulletListProps> = ({ children }) => {
  return <ul className={styles.bulletList}>{children}</ul>;
};

interface BulletItemProps {
  children: ReactNode;
}

export const BulletItem: React.FC<BulletItemProps> = ({ children }) => {
  return (
    <li className={styles.bulletItem}>
      <span className={styles.icon}>
        <Check size={16} aria-hidden="true" />
      </span>
      <span className={styles.content}>{children}</span>
    </li>
  );
};
